/*
 * 苏州海管家物流科技有限公司（https://www.hgj.com/）.
 * 苏公网安备32059002003385号 © 2015-2023 Hgj.com All Rights Reserved. | 苏ICP备15030950号.
 * @Date: 2022.08.11.
 * @Author
 * @Description 企微 - 公用 方法 定义 与业务模块相关 .
 **/
import QRCode from 'qrcode'
import { ElMessage } from '@hgj/element-plus'
import dayjs from 'dayjs'
import {
  domainNameObj,
  enterpriseFormDomain,
  jointPlatformDomain,
} from './constant'
import { returnLoginDomain } from '@/utils/index'
import { useAuthStore } from '@/store/authStore'
import { useProxyInsurance } from '@/hooks/useProxyInsurance'
import { Base64 } from 'js-base64'
import { i18n } from '@/i18n'
import { getAbsoluteBaseUrl } from '@/utils/base'
const { t } = i18n.global
import { Document, Paragraph, TextRun, Packer } from 'docx'
import { saveAs } from 'file-saver'

/**
 *@Description 序列号 table 序号 .
 *@Return .
 **/
export const formatSerialNo = (param: Record<string, any>, index: number) => {
  const num = param.num || param.pageNo
  const size = param.size || param.pageSize

  return size * (num - 1) + index + 1
}
/**
 *@Description 去 登录 .
 *@Return .
 **/
export const gotoLogin = (s = '') => {
  const appBase = getAbsoluteBaseUrl()
  let str = s || returnLoginDomain()
  console.log('str===============', str)
  if (str === 'l') {
    // 注册
    // const env = projectEnvironment('notProd')
    const environment: string = projectEnvironment()
    const origin = jointPlatformDomain[environment]
    str = `${origin}/register?redirect_url=${appBase}&source_type=1`
  }

  console.log(str, 999)
  window.location.href = str
}
/**
 *@Description 当前项目 所在环境 .
 *@Return 联合平台 产线域名不需要 prod .
 **/
export const projectEnvironment = (type?: string) => {
  const str: string = import.meta.env.VITE_APP_PREFIX
  if (type === 'notProd' && str === 'prod-') {
    return ''
  } else {
    return str || 'prod-'
  }
}
/**
 *@Description 企点 返回 不同环境下 服务器 域名 地址 .
 *@Return .
 **/
export const returnBaseUrl = (plat?: string) => {
  let str = ''
  const prefix: string = projectEnvironment()

  if (['dev-', 'beta-', 'prod-'].includes(prefix)) {
    if (plat === 'enterprise') {
      // 中台 企业 认证
      str = enterpriseFormDomain[prefix]
    } else {
      str = domainNameObj[prefix]
    }
  } else {
    str = `https://${prefix}file-ingress.hgj.com/whale-nas-manager-server`
  }
  return str
}
/**
 *@Description 联合平台 返回 不同环境下 服务器 域名 地址 .
 *@Return .
 **/
export const returnPlatformDomain = () => {
  let str = ''
  const prefix: string = projectEnvironment()

  if (['dev-', 'beta-', 'prod-'].includes(prefix)) {
    str = jointPlatformDomain[prefix]
  } else {
    console.log('联合 平台 环境 prefix:', prefix)
  }
  return str
}
/**
 *@Description 不同环境下nas上 图片、文件 所在服务器 地址 用于预览、下载 .
 *@Return .
 **/
export const getNasFileURL = (fileId: string) => {
  const baseURL = returnBaseUrl()
  return `${baseURL}/pass/proxy/${fileId}`
}
/**
 *@Description 创建二维码 .
 *@Return .
 **/
export const creatQrCode = (qrData: any) => {
  let imgUrl = ''
  let imgErrorUrl = ''

  const margin = qrData.margin || 1
  const quality = qrData.quality || 0.3
  const urlData = qrData.urlData || 'error'

  const opts: any = {
    margin,
    quality,
    type: 'image/png',
    errorCorrectionLevel: 'H',
    color: {
      dark: '#000',
      light: '#fff',
    },
  }

  QRCode.toDataURL(urlData, opts, (err, url) => {
    if (err) {
      throw err
    }
    urlData === 'error' ? (imgErrorUrl = url) : (imgUrl = url)
  })
  // with then
  // QRCode.toDataURL('I am a pony!').then(url => {
  //     console.log('then url:', url)
  // }).catch(err => {
  //     console.error(err)
  // })
  // With async/await
  // const generateQR = async text => {
  //     try {
  //         console.log('await url:', await QRCode.toDataURL(text))
  //     } catch (err) {
  //         console.error(err)
  //     }
  // }
  // generateQR('6')
  return { imgUrl, imgErrorUrl }
}
/**
 *@Description 将传入的数组字符串转换成数组.
 *  @param {String} arrStr
 *@Return .
 **/
export const convertArrStr2Arr = (arrStr = '') => {
  if (!arrStr) {
    return []
  } else if (arrStr[0] !== '[') {
    return [arrStr]
  }
  try {
    const setArr = arrStr
      .replace(/\[|\]/g, '')
      .split(',')
      .map((item) => item.trim())

    return [...new Set(setArr)].filter((item) => item !== null)
  } catch (error) {
    console.error(error)
    return []
  }
}
/**
 * @Description 对时间控件 的开始，结束时间进行转换    --- 在查询区域 组件中使用 .
 * __dateRange开头的会被解析，分解成两个参数， 如：
 * __dateRange$createFrom$createTo$YYYY-MM-DD 会被分解成 createFrom 和 createTo ，
 * __dateRange&range[]=createFrom&range[]=createTo&format=YYYY-MM-DD 会被分解成 createFrom 和 createTo，format参数是格式化
 * @Return .
 **/
export const convertDateRange = (obj: any) => {
  const { id, value } = obj
  const arr: string[] = id.split('$')
  const defaultFormat = 'YYYY-MM-DD' //  HH:mm:ss
  const format: string = arr[3] || defaultFormat
  const data: { [key: string]: string } = {}

  if (value && value.length > 0) {
    ;[data[arr[1]], data[arr[2]]] = [
      `${dayjs(value[0]).format(format)} 00:00:00`,
      `${dayjs(value[1]).format(format)} 23:59:59`,
    ]
  } else {
    data[arr[1]] = ''
    data[arr[2]] = ''
  }
  return data
}
/**
 *@Description 文件 导出 .
 *@Return .
 **/
export const exportMethod = (param: any, exportFinally?: any) => {
  const t = param?.eTemplate || '' // 当传入下载地址的时候 就不需要 导出模板了
  const f = param?.eFormat || 'xlsx' // 格式
  const time = param?.eTime || dayjs().format('YYYY-MM-DD_HH_mm_ss')
  const type =
    param?.eType ||
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

  try {
    const url =
      param?.eUrl || window.URL.createObjectURL(new Blob([t], { type }))

    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', `${param?.eName}_${time}.${f}`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (e) {
    console.log('export catch:', e)
  } finally {
    exportFinally && exportFinally()
    console.log('export finally')
  }
}
/**
 *@Description 加载 js、css 文件 .
 *@Return .
 **/
export const loadScript = (type = 'js', url: string) => {
  let flag = false

  return new Promise<void>((resolve) => {
    const head = document.getElementsByTagName('head')[0]
    // console.log('head-------', head)

    if (type === 'js') {
      const scriptDom = document.getElementsByTagName('script') as any

      for (let i = 0; i < scriptDom.length; i++) {
        const item = scriptDom[i]

        if ((item.src || '').indexOf(url) !== -1) {
          flag = true
          resolve()
        }
      }
    } else if (type === 'css') {
      const linkDom = document.getElementsByTagName('link') as any

      for (let i = 0; i < linkDom.length; i++) {
        const item = linkDom[i]
        if ((item.href || '').indexOf(url) !== -1) {
          flag = true
          resolve()
        }
      }
    }

    if (flag) return false

    let script!: HTMLScriptElement | HTMLLinkElement

    if (type === 'js') {
      script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url
    } else if (type === 'css') {
      script = document.createElement('link')
      script.rel = 'stylesheet'
      script.type = 'text/css'
      script.href = url
    }

    head.appendChild(script)

    script.onload = function () {
      resolve()
    }
  })
}
/**
 * @param 浏览器 内核
 * @returns
 */
export const returnBrowserKernel = () => {
  const userAgent = navigator.userAgent // 取得浏览器的userAgent字符串

  const isEdge = userAgent.indexOf('Edge') > -1 // 判断是否IE的Edge浏览器
  const isFF = userAgent.indexOf('Firefox') > -1 // 判断是否Firefox浏览器
  const isOpera = userAgent.indexOf('Opera') > -1 // 判断是否Opera浏览器
  const isChrome =
    userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 // 判断Chrome浏览器
  const isSafari =
    userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1 // 判断是否Safari浏览器
  const isIE =
    userAgent.indexOf('compatible') > -1 &&
    userAgent.indexOf('MSIE') > -1 &&
    !isOpera // 判断是否IE浏览器

  // 判断IE版本
  if (isIE) {
    const reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    const fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion === 7) {
      return 'IE7'
    } else if (fIEVersion === 8) {
      return 'IE8'
    } else if (fIEVersion === 9) {
      return 'IE9'
    } else if (fIEVersion === 10) {
      return 'IE10'
    } else if (fIEVersion === 11) {
      return 'IE11'
    } else {
      return '0'
    } // IE版本过低
  }

  if (isFF) return 'FF'
  if (isEdge) return 'Edge'
  if (isOpera) return 'Opera'
  if (isSafari) return 'Safari'
  if (isChrome) return 'Chrome'
}
/**
 * 判断响应是否成功
 * @export
 * @param {object} result 响应的数据、 {any} msg 提示信息
 * @returns 成功与否
 */
export const isSuccess = (result: any, msg?: string) => {
  if (!result) return false
  const str = result.message === '保存成功' || result.code === 200
  if (msg) {
    str
      ? ElMessage.success(t('common.actionSuccess', { action: msg }))
      : ElMessage.error(t('common.actionFailed', { action: msg }))
  }
  return str
}

export const copyFunc = (text: string) => {
  const oInput = document.createElement('input')
  oInput.value = text
  document.body.appendChild(oInput)
  oInput.select() // 选择对象
  document.execCommand('Copy') // 执行浏览器复制命令
  oInput.className = 'oInput'
  oInput.style.display = 'none'
  ElMessage.success(t('common.copySuccess'))
}

/**
 * @description: 获取headers
 * @return { Record<string, unknown> }
 */
export const getHeaders = (): Record<string, any> => {
  const { getApprovalAgentHeader } = useProxyInsurance()
  return {
    'access-token': useAuthStore().getToken,
    'app-name': 'sass-insurance-web',
    ...getApprovalAgentHeader(),
  }
}

export const createFileViewUrl = (fileKey: string) => {
  return `https:${
    import.meta.env.VITE_FILE_VIEW_HOST
  }onlinePreview?url=${encodeURIComponent(
    Base64.encode(`${returnBaseUrl()}/pass/proxy/${fileKey}`),
  )}&forceUpdatedCache=true`
}

/**
 * 下载文件
 * @param {string} fileKey
 * @returns
 */
export const downloadFile = async (fileKey?: string) => {
  if (!fileKey) return ElMessage.warning(t('common.fileNotExist'))
  window.location.href = `${import.meta.env.VITE_APP_NAS_PREV_URL}/pass/proxy/${fileKey}`
}

/**
 * 生成只包含文字的docx文件并下载
 * @param {string} text
 * @returns
 */
export const generateDocFileAndDownload = (text: string, fileName: string) => {
  const document = new Document({
    sections: [
      {
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text,
                size: 16,
              }),
            ],
          }),
        ],
      },
    ],
  })
  Packer.toBlob(document).then((blob) => {
    saveAs(blob, fileName)
  })
}

const base64ToBlob = (code: string) => {
  code = code.replace(/[\n\r]/g, '')
  // atob() 方法用于解码使用 base-64 编码的字符串。
  const raw = window.atob(code)
  const rawLength = raw.length
  const uInt8Array = new Uint8Array(rawLength)
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i)
  }
  return new Blob([uInt8Array], { type: 'application/pdf' })
}

export const viewPdfPreview = (content: string) => {
  const blob = base64ToBlob(content)
  if (window.navigator && window.navigator?.msSaveOrOpenBlob) {
    // 兼容IE浏览器
    window.navigator?.msSaveOrOpenBlob(blob)
  } else {
    // 其他浏览器
    const fileURL = URL.createObjectURL(blob)
    window.open(fileURL)
  }
}
